<script>
import Layout from "@/views/layouts/main.vue";
import apiEndpoints from "@/services/apiEndpoints";
import FullCalendar from '@fullcalendar/vue'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import interactionPlugin from '@fullcalendar/interaction'
import CommonTableComponent from "@/components/table.vue";
import tableSearch from "@/mixins/tableSearch";
import pagination from "@/mixins/pagination";
import TabReservations from "@/views/pages/project/schedule/reservation/index";
import datetime from "@/mixins/datetime";
import router from "@/mixins/router";
import ModalRegisterReservationCar from "@/views/pages/project/schedule/modals/ModalRegisterReservationCar.vue";
import ModalRegisterReservationFactory from "@/views/pages/project/schedule/modals/ModalRegisterReservationFactory.vue";
import ModalRegisterReservationStaff from "@/views/pages/project/schedule/modals/ModalRegisterReservationStaff.vue";
import ModalGoogleScheduleStaff from "@/views/pages/project/schedule/modals/ModalGoogleScheduleStaff.vue";
import systemCode from "@/mixins/systemCode";
import {mapState} from "vuex";
import DatePicker from "vue2-datepicker";
import {BIconChevronDoubleLeft,BIconChevronLeft,BIconChevronDoubleRight,BIconChevronRight} from 'bootstrap-vue'
import Multiselect from "vue-multiselect";
import selectMultipleCarWithCheckbox from "@/views/pages/project/schedule/mixins/selectMultipleCarWithCheckbox";
import selectMultipleReservationStatus1Checkbox from "@/views/pages/project/schedule/mixins/selectMultipleReservationStatus1Checkbox";
import selectMultipleDepartmentOptionsCheckbox from "@/views/pages/project/schedule/mixins/selectMultipleDepartmentOptionsCheckbox";
import schedule from "./mixins/schedule";
import appConfig from "@/app.config.json";
import moment from "moment";

export default {
  name: 'ListSchedulesBySale',
  page: {
    title: "スケジュール一覧（営業用）",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    FullCalendar,
    CommonTableComponent,
    TabReservations,
    ModalRegisterReservationCar,
    ModalRegisterReservationStaff,
    ModalRegisterReservationFactory,
    DatePicker,
    BIconChevronDoubleLeft,
    BIconChevronLeft,
    BIconChevronDoubleRight,
    BIconChevronRight,
    Multiselect,
    ModalGoogleScheduleStaff
  },
  mixins: [
    pagination,
    tableSearch,
    datetime,
    router,
    systemCode,
    selectMultipleCarWithCheckbox,
    schedule,
    selectMultipleReservationStatus1Checkbox,
    selectMultipleDepartmentOptionsCheckbox
  ],
  data() {
    return {
      isLoading: false,
      //optionDepartment: [],
      filters: {
        start_datetime: '',
        end_datetime: '',
        type: 'car',
        department: "",
        zz_car_type_parent_id: [],
        zz_reservation_status_1_id: [],
        //zz_division: null,
        department_id: [],
        column: "department_id",
        dir: "ASC",
      },
      calendarOptions: {
        resourceOrder: 'index',
        plugins: [
          resourceTimelinePlugin,
          interactionPlugin,
        ],
        visibleRange: {
          start: this.getToday(),
          end: this.addOrSubtractTimeFromDate(6, 'days', 'add', this.getToday(), 'YYYY-MM-DD 23:59:59')
        },
        headerToolbar: false,
        schedulerLicenseKey: process.env.VUE_APP_FULLCALENDAR_LICENSE_KEY,
        initialView: 'resourceTimeline',
        locale: 'ja',
        weekends: true,
        slotMinTime: '00:00:00',
        slotMaxTime: '23:00:00',
        resources: [],
        resourceAreaWidth: '15%',
        resourceAreaColumns: [
          {
            headerContent: '車両',
            headerClassNames: 'font-size-18',
          },
        ],
        contentHeight: 630,
        resourceLabelClassNames: 'align-middle',
        slotLabelClassNames: 'fc-text-black',
        expandRows: true,
        timeZone: 'UTC',
        events: [],
        eventClick: (info) => this.handleClickEvent(info),
        eventDidMount: info => {
          this.handleEventDidMounted(info);
        },
      },
      selectedDivision: '',
      isEditCarPredetermined: false,
      isEditStaffPredetermined: false,
      isEditFactoryPredetermined: false,
      selectedDate: this.getToday(),
      calendarView: 'resourceTimeline',
    };
  },
  created() {
    this.getData();
    //this.getOptionsDepartment();
  },
  methods: {
    setTimezoneStartEndDisplay() {
      this.$nextTick(() => {
        this.calendarOptions.slotMinTime = this.findTimezoneStart().system_code_value || '00:00:00';
        this.calendarOptions.slotMaxTime = this.findTimezoneEnd().system_code_value || '23:00:00';
      })
    },
    //async getOptionsDepartment() {
      //const response = await this.$http.get(apiEndpoints.department_list_options, {
        //...this.filters,
      //});
      //const { status, data } = response;
      //if (status) {
        //this.departmentOptions = data.result;
      //}
    //},
    async getData() {
      this.isLoading = true
      this.filters = {
        ...this.filters,
        // start_datetime: this.filters?.start_datetime || this.getToday(),
        // end_datetime: this.filters?.end_datetime || this.addOrSubtractTimeFromDate(6, 'days', 'add', this.getToday(), 'YYYY-MM-DD 23:59:59'),
      }

      // 日跨ぎの予定を取得するため、表示日より少し前後の予定を含めておく
      // this.filtersを使ってしまうとタブ切り替えやフィルターの際にどんどん計算が積みあがってしまうため
      // 基準日付はselectedDateにする
      // this.filters.start_datetime = moment(this.filters.start_datetime).add(-2, 'days').format('YYYY-MM-DD');
      // this.filters.end_datetime = moment(this.filters.end_datetime).add(2, 'days').format('YYYY-MM-DD');
      this.filters.start_datetime = moment(this.selectedDate).format('YYYY-MM-DD');
      this.filters.end_datetime = moment(this.selectedDate).add(7, 'days').format('YYYY-MM-DD');

      const url = apiEndpoints.list_schedule_by_type()
      const {status, data} = await this.$http.get(url, this.filters)

      if (status) {
        switch (this.filters.type) {
          case 'car':
            this.mapScheduleByCar(data.result)
            break;
          case 'staff':
            this.mapScheduleByStaff(data.result)
            break;
          case 'vendor':
            this.mapScheduleByVendor(data.result)
            break;
          default:
            break;
        }
      }
      this.isLoading = false
    },
    mapScheduleByCar(data) {
      let resources = [];
      let events = [];
      data.forEach((car, index) => {
        car.assigned_cars_by_schedule.forEach(schedule => {
          events.push({
            resourceId: car.id,
            start: schedule.start_datetime,
            end: schedule.end_datetime,
            ...this.eventObj(schedule)
          })
        })
        car.car_predetermined_schedules.forEach(car_predetermined_schedule => {
          events.push({
            resourceId: car.id,
            start: car_predetermined_schedule.start_datetime,
            end: car_predetermined_schedule.end_datetime,
            car_predetermined_schedule_id: car_predetermined_schedule.id,
            title: '車両予約: ' + car_predetermined_schedule.zz_car_predetermined_schedule_type.car_predetermined_schedule_type + ' ' + car_predetermined_schedule.title,
          })
        })
        resources.push({
          index,
          id: car.id,
          title: car.name_with_number,
        })
      });
      this.setCalendarOptions({headerContent: '車両', resources, events})
    },
    mapScheduleByStaff(data) {
      let resources = [];
      let events = [];
      data.forEach((staff, index) => {
        staff.assigned_staffs_by_schedule.forEach(schedule => {
          events.push({
            resourceId: staff.id,
            start: schedule.start_datetime,
            end: schedule.end_datetime,
            ...this.eventObj(schedule)
          })
        });
        staff.google_schedule.map(item => {
          var start = this.formatDate(item.start_datetime, "YYYY-MM-DDTHH:mm:00") ?? "";
          var end =  this.formatDate(item.end_datetime, "YYYY-MM-DDTHH:mm:00") ?? "";
          if(item.is_all_day){
            start = this.formatDate(item.start_datetime, "YYYY-MM-DDT00:00:00") ?? "";
            end =  this.formatDate(item.end_datetime, "YYYY-MM-DDT23:59:59") ?? "";
          }

          events.push({
            resourceId: staff.id,
            start: start,
            end: end,
            google_schedule_id: item.id ?? '',
            google_schedule_title: item.title ?? '',
            google_schedule_content: item.contents ?? '',
            google_schedule_is_all_day: item.is_all_day,
            ...this.eventObj(item)
          });
        });

        if(staff.staff_predetermined_schedule){
          staff.staff_predetermined_schedule.map(item => {
            events.push({
              start: item.start_datetime,
              end: item.end_datetime,
              resourceId: staff.id,
              staff_predetermined_title: item.title ?? '',
              staff_predetermined_content: item.contents ?? '',
              staff_predetermined_id: item.id ?? '',
              ...this.eventObj(item)
            });
          });
        }

        resources.push({
          index,
          id: staff.id,
          title: staff.name_with_department,
        });
      });
      this.setCalendarOptions({headerContent: '従業員', resources, events})
    },
    mapScheduleByVendor(data) {
      let resources = [];
      let events = [];
      data.forEach((vendor_site, index) => {
        if (!resources.some(resource => resource.id == vendor_site.id)) {
          resources.push({
          index,
          id: vendor_site.id,
          title: vendor_site.name_abbreviated,
          })
        }
        vendor_site.disposal_sites.forEach(disposal_site_by_waste_category => {
          disposal_site_by_waste_category.disposal_site_by_waste.forEach(disposal_site_by_waste => {
            disposal_site_by_waste.schedules.forEach(schedule => {
              let vendor_site_id;
              let vendor_site_name = null;
              //get default vendor site id mapping
              vendor_site_id = vendor_site.id
              // 2 special case need to mapping name of factory to vendor site id
              // 排出の場合の排出事業場と委託先事業場のマッチングは API 側で行っているのでチェック不要
              // if (schedule.zz_work_order_type_id === this.$constant.work_order_type.discharge) {
              //   //get name from zz_discharger_site_4
              //   vendor_site_name = schedule.work_reservation?.work_order?.case?.discharger_site?.zz_discharger_site4?.discharger_site_4
              // }

              // 積替保管区間2も区間1の委託先事業場と同じものに含まれているのでここでのマッチングは不要
              // if (
              //   schedule.zz_work_order_type_id === this.$constant.work_order_type.transshipment_storage
              //   && parseInt(schedule.transport_and_hold_section) === 2
              // ) {
              //   //get name from zz_vendor_site_4
              //   let transport_contracts = schedule.work_reservation?.work_order?.transport_contracts[0];
              //   vendor_site_name = transport_contracts.vendor_site_id_section_1?.zz_vendor_site4?.vendor_site_4 || null
              // }
              // //if there is vendor_site_name exist from 2 special case then find factory for schedule
              // if (vendor_site_name) {
              //   vendor_site_id = data.find(vender_site_find => vender_site_find.name_abbreviated === vendor_site_name)?.id ?? null;
              // }

              if (vendor_site_id) {
                events.push({
                  resourceId: vendor_site_id,
                  start: schedule.start_datetime,
                  end: schedule.end_datetime,
                  ...this.eventObj(schedule)
                });
              }
            })
          })
        })
        if(vendor_site.factory_predetermined_schedule){
          vendor_site.factory_predetermined_schedule.map(item => {
            events.push({
              resourceId: vendor_site.id,
              start: item.start_datetime ?? '',
              end: item.end_datetime ?? '',
              factory_predetermined_title: item.title ?? '',
              factory_predetermined_content: item.contents ?? '',
              factory_predetermined_id: item.id ?? '',
              ...this.eventObj(item)
            });
          });
        }

      });
      this.setCalendarOptions({headerContent: '工場', resources, events})
    },
    eventObj(schedule) {
        var start_time = this.formatDate(schedule.start_datetime, "HH:mm") ?? "";
        var end_time =  this.formatDate(schedule.end_datetime, "HH:mm") ?? "";
      if(schedule.is_all_day){
        start_time = "00:00";
        end_time =  "23:59";
      }

      return {
        className: `event-schedule-${schedule.id ?? ''}`,
        start_hour: start_time,
        end_hour: end_time,
        work_order_name: schedule.work_reservation?.work_order?.name ?? "",
        work_reservation_remarks: schedule.work_reservation?.remarks ?? "",
        discharger_name: schedule.work_reservation?.work_order?.case?.discharger?.name_abbreviated ?? "",
        discharger_site_name: schedule.work_reservation?.work_order?.case?.discharger_site?.name_abbreviated ?? "",
        discharger_site_user1_name: schedule.work_reservation?.work_order?.case?.discharger_site?.user1?.user_name ?? "",
        vendor: schedule.work_reservation?.work_order?.case?.vendor?.name_abbreviated ?? "",
        assigned_cars_by_schedule: schedule.assigned_cars_by_schedule ?? [],
        assigned_staffs_by_schedule: schedule.assigned_staffs_by_schedule ?? [],
        waste_or_services_by_schedule:
          schedule.waste_or_services_by_schedule ?? [],
        zz_reservation_status_1_id: schedule.zz_reservation_status_1_id ?? "",
        zz_reservation_status2: schedule.zz_reservation_status2 ?? "",
        schedule_id: schedule.id ?? "",
        schedule_id_tooltip: (schedule.id ?? "") + (+new Date * Math.random()).toString(36).substring(0,6),
        implements: schedule.work_reservation?.work_order?.implements ?? [],
        work_reservation_id: schedule.work_reservation_id ?? "",
        compliance_error: schedule.compliance_error ?? false,
      };
    },
    setCalendarOptions({headerContent, resources, events}) {
      this.calendarOptions.resources = resources.filter((obj, index, self) =>
        index === self.findIndex((t) => (t.id === obj.id))
      );
      this.calendarOptions.events = events
      this.calendarOptions.resourceAreaColumns[0].headerContent = headerContent
    },
    //onChangeDivision(value) {
      //this.filters.zz_division = value;
      //this.getData();
    //},
    //onChangeDepartment(value) {
      //this.filters.department = value;
      //this.getData();
    //},
    backToList() {
      const previousRoute = this.$route.params.previousRoute;
      this.$router.push({
        name: 'home',
        query: previousRoute && previousRoute.query ? previousRoute.query : {}
      })
    },
    openRegisterScheduleCarModal(carPredeterminedScheduleId) {
      this.$refs.modal_register_schedule_car.openModal(null, carPredeterminedScheduleId);
    },
    openRegisterScheduleStaffModal(staffPredeterminedScheduleId) {
      this.$refs.modal_register_schedule_staff.openModal(null, staffPredeterminedScheduleId);
    },
    openRegisterScheduleFactoryModal(factoryPredeterminedId) {
      this.$refs.modal_register_schedule_factory.openModal(null, factoryPredeterminedId);
    },
    openGoogleScheduleClick(info){
      const infoGoogleSchedule = {
        id: info.event.extendedProps.google_schedule_id,
        title: info.event.extendedProps.google_schedule_title,
        start_date: this.formatDate(info.event.start),
        end_date: this.formatDate(info.event.end),
        start_hour: info.event.extendedProps.start_hour,
        end_hour: info.event.extendedProps.end_hour,
        content: info.event.extendedProps.google_schedule_content,
        is_all_day: info.event.extendedProps.google_schedule_is_all_day,
      };
      this.$refs.modal_google_schedule_staff.openModal(infoGoogleSchedule);
    },
    handleClickEvent(info) {
      if (info.event.extendedProps.work_reservation_id) {
        return this.redirectRoute(
          'projects.work_reservations.schedule.detail_for_sale',
          {
            work_reservation_id: info.event.extendedProps.work_reservation_id,
          },
          {
            schedule_id: info.event.extendedProps.schedule_id,
          },
          this.$route.query,
          'projects/work-reservations/schedules'
        );
      }
      if (info.event.extendedProps.car_predetermined_schedule_id) {
        const carPredeterminedScheduleId = info.event.extendedProps.car_predetermined_schedule_id
        this.openRegisterScheduleCarModal(carPredeterminedScheduleId);
      }
      if (info.event.extendedProps.google_schedule_id) {
        this.openGoogleScheduleClick(info);
      }
      if (info.event.extendedProps.staff_predetermined_id) {
        const staffPredeterminedScheduleId = info.event.extendedProps.staff_predetermined_id
        this.openRegisterScheduleStaffModal(staffPredeterminedScheduleId);
      }
      if (info.event.extendedProps.factory_predetermined_id) {
        const factoryPredeterminedScheduleId = info.event.extendedProps.factory_predetermined_id
        this.openRegisterScheduleFactoryModal(factoryPredeterminedScheduleId);
      }
    },
    showCalendarView(calendarApi) {
      if (this.calendarView === 'resourceTimeline') {
        this.filters.start_datetime = this.addOrSubtractTimeFromDate(0, 'days', 'add', this.selectedDate, 'YYYY-MM-DD HH:mm:ss')
        this.filters.end_datetime = this.addOrSubtractTimeFromDate(6, 'days', 'add', this.selectedDate, 'YYYY-MM-DD 23:59:59')

        calendarApi.setOption('visibleRange', { start: this.filters.start_datetime, end: this.filters.end_datetime });
      } else {
        calendarApi.gotoDate(this.selectedDate);

        this.filters.start_datetime = this.addOrSubtractTimeFromDate(0, 'days', 'add', this.selectedDate, 'YYYY-MM-DD HH:mm:ss')
        this.filters.end_datetime = this.addOrSubtractTimeFromDate(0, 'days', 'add', this.selectedDate, 'YYYY-MM-DD 23:59:59')
      }

      this.getData();
    },
    onChangeSelectedDate() {
      let calendarApi = this.$refs.fullcalendar.getApi();

      this.showCalendarView(calendarApi);
    },
    onChangeView(mode) {
      this.calendarView = mode;
      let calendarApi = this.$refs.fullcalendar.getApi();
      calendarApi.changeView(mode);

      this.showCalendarView(calendarApi);
    },
    onChangeFiltersType(type) {
      this.filters.type = type;
    },
    gotoToday() {
      this.selectedDate = this.getToday();
      let calendarApi = this.$refs.fullcalendar.getApi();

      this.showCalendarView(calendarApi);
    },
    gotoPrev() {
      this.handleBtnNextOrPrevCalendar('subtract');
    },
    gotoDoublePrev() {
      this.handleBtnDoubleNextOrPrevCalendar('subtract');
    },
    gotoNext() {
      this.handleBtnNextOrPrevCalendar('add');
    },
    gotoDoubleNext() {
      this.handleBtnDoubleNextOrPrevCalendar('add');
    },
    handleBtnNextOrPrevCalendar(operationType) {
      if (this.calendarView === 'resourceTimelineDay') {
        const startHour = this.addOrSubtractHours(this.calendarOptions.slotMinTime, 1, operationType);
        const endHour = this.addOrSubtractHours(this.calendarOptions.slotMaxTime, 1, operationType);

        if (startHour && endHour) {
          this.$nextTick(() => {
            this.calendarOptions.slotMinTime = startHour;
            this.calendarOptions.slotMaxTime = endHour;
          })

          this.getData();
        }
      } else {
        let calendarApi = this.$refs.fullcalendar.getApi();
        this.selectedDate = this.addOrSubtractTimeFromDate(1, 'days', operationType, this.selectedDate, 'YYYY-MM-DD');

        this.showCalendarView(calendarApi);
      }
    },
    handleBtnDoubleNextOrPrevCalendar(operationType) {
      let calendarApi = this.$refs.fullcalendar.getApi();
      this.selectedDate = this.addOrSubtractTimeFromDate(this.durationOnCalendarView, 'days', operationType, this.selectedDate, 'YYYY-MM-DD');

      this.showCalendarView(calendarApi);
    },
    btnColorFiltersType(type) {
      if (this.filters.type === type) {
        return 'primary';
      }

      return 'dark';
    },
    btnColorCalendarView(view) {
      if (this.calendarView === view) {
        return 'primary';
      }

      return 'dark';
    },
    handleEventDidMounted(info) {
      const EVENT_BG_COLOR = this.$constant.zzReservationStatus1BgColor

      if (info.event.extendedProps.car_predetermined_schedule_id || info.event.extendedProps.google_schedule_id || info.event.extendedProps.factory_predetermined_id || info.event.extendedProps.staff_predetermined_id) {
        info.el.style.backgroundColor = 'white';
        info.el.style.borderColor = 'black';
      }
      if (info.event.extendedProps.zz_reservation_status_1_id) {
        info.el.style.backgroundColor =
          EVENT_BG_COLOR[info.event.extendedProps.zz_reservation_status_1_id];
        info.el.style.borderColor =
          EVENT_BG_COLOR[info.event.extendedProps.zz_reservation_status_1_id];
      }
      if(info.event.extendedProps.compliance_error){
        info.el.style.borderColor = 'red';
      }
    },
  },
    performDebounceSearch () {
      this.resetToFirstPage();
    },
    performDebounceSearch () {
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    updateUrlFilters () {
      this.getData()
    },
  computed: {
    ...mapState("options", ["system_codes"]),
    //zzDivisions() {
    //  return this.$store.getters["options/options_tables"].zz_divisions ?? [];
    //},
    durationOnCalendarView() {
      return this.calendarView === 'resourceTimeline' ? 7 : 1;
    },
  },
  watch: {
    'filters.type'(value) {
      this.getData()
    },
    '$route' (to, from) {
      this.getData();
    },
    system_codes: {
      handler(val) {
        if (val.length) {
          this.setTimezoneStartEndDisplay()
        }
      },
      immediate: true,
    },
  },
};
</script>

<template>
  <Layout>  
    <b-row>
      <b-overlay
        :show="isLoading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
        class="d-inline-block"
      >
        <b-card class="custom-card">
          <ModalRegisterReservationCar
            ref="modal_register_schedule_car"
            :isEdit="isEditCarPredetermined"/>
          <ModalRegisterReservationStaff
            ref="modal_register_schedule_staff"
            :isEdit="isEditStaffPredetermined"
            />
          <ModalRegisterReservationFactory
            ref="modal_register_schedule_factory"
            :isEdit="isEditFactoryPredetermined"
          />
          <ModalGoogleScheduleStaff
            ref="modal_google_schedule_staff"
          />
          <b-row>
            <b-col class="mb-3" cols="12">
              <b-row>
                  <b-col sm="auto" >
                    <b-button-group>
                      <b-button :variant="btnColorFiltersType('car')" @click="onChangeFiltersType('car')">車両</b-button>
                      <b-button :variant="btnColorFiltersType('staff')" @click="onChangeFiltersType('staff')">従業員</b-button>
                      <b-button :variant="btnColorFiltersType('vendor')" @click="onChangeFiltersType('vendor')">工場</b-button>
                    </b-button-group>
                  </b-col>
                  <b-col sm="auto">
                    <b-button-group>
                      <b-button :variant="btnColorCalendarView('resourceTimeline')" @click="onChangeView('resourceTimeline')">週</b-button>
                      <b-button :variant="btnColorCalendarView('resourceTimelineDay')" @click="onChangeView('resourceTimelineDay')">日</b-button>
                    </b-button-group>
                  </b-col>
                  <b-col sm="auto">
                    <b-button-group>
                      <b-button variant="dark" @click="gotoDoublePrev()"><b-icon-chevron-double-left variant="white" /></b-button>
                      <b-button variant="dark" @click="gotoPrev()"><b-icon-chevron-left variant="white" /></b-button>
                    </b-button-group>
                  </b-col>
                  <b-col sm="auto"><b-button variant="dark" size="df" @click="gotoToday()" :disabled="this.isToday(selectedDate)">今日</b-button></b-col>
                  <b-col sm="auto">
                    <date-picker
                      lang="ja"
                      v-model="selectedDate"
                      :clearable="false"
                      placeholder="YYYY-MM-DD"
                      format="YYYY-MM-DD"
                      value-type="YYYY-MM-DD"
                      position="left"
                      type="date"
                      @change="onChangeSelectedDate"
                    ></date-picker>
                  </b-col>
                  <b-col sm="auto">
                    <b-button-group>
                      <b-button variant="dark" @click="gotoNext()"><b-icon-chevron-right variant="white" /></b-button>
                      <b-button variant="dark" @click="gotoDoubleNext()"><b-icon-chevron-double-right variant="white" /></b-button>
                    </b-button-group>
                  </b-col>
            <b-col sm="auto" class="multiple-select-custom" v-if="filters.type === 'staff'">
              <Multiselect
                :options="optionDepartment"
                :multiple="true"
                v-model="selectedDepartmentOptions"
                @input="onChangeDepartment"
                placeholder=""
                :close-on-select="false"
                group-values="attributes"
                group-label="selectAll"
                label="name"
                track-by="id"
                :group-select="true"
                selectLabel=""
                selectGroupLabel=""
                deselectLabel=""
                deselectGroupLabel=""
                selectedLabel=""
              >
                <template #option="props">
                  <div class="option__desc d-flex align-items-center gap-2" v-if="props.option['$groupLabel']">
                    <input type="checkbox" @click.self.prevent="checkDepartmentCheckedAll()"
                           id="name_all" :checked="checkDepartmentCheckedAll()">
                    <span class="option__small">{{ props.option.$groupLabel }}</span>
                  </div>
                  <div class="option__desc d-flex align-items-center gap-2" v-else>
                    <input type="checkbox" :id="`name_${props.option.id}`"
                           :checked="checkDepartmentChecked(props.option)">
                    <span class="option__small">{{ props.option.name }}</span>
                  </div>
                </template>
                <template #selection="{ values, search, isOpen }">
                  <span class=""
                        v-if="values.length == 0 || selectedDepartmentOptions.length == optionDepartment[0].attributes.length"
                  >所属：全て</span>
                  <span class="multiselect__single"
                        v-if="values.length && values.length != optionDepartment[0].attributes.length"
                  >{{ selectedDepartmentOptions.map(item => item.name).join('、') }}</span>
                </template>
              </Multiselect>
            </b-col>
                  <b-col sm="auto" class="multiple-select-custom" v-if="filters.type === 'car'">
                    <Multiselect
                      :options="zzCarTypesParent"
                      :multiple="true"
                      v-model="selectedCarTypeParent"
                      @input="onChangeCarTypeParent"
                      placeholder=""
                      :close-on-select="false"
                      group-values="attributes"
                      group-label="selectAll"
                      label="car_types_parent"
                      track-by="id"
                      :group-select="true"
                      selectLabel=""
                      selectGroupLabel=""
                      deselectLabel=""
                      deselectGroupLabel=""
                      selectedLabel=""
                      >
                        <template #option="props">
                          <div class="option__desc d-flex align-items-center gap-2" v-if="props.option['$groupLabel']">
                          <input type="checkbox" @click.self.prevent="checkCarCheckedAll()" id="car_types_parent_all" :checked="checkCarCheckedAll()">
                          <span class="option__small">{{ props.option.$groupLabel }}</span>
                        </div>
                        <div class="option__desc d-flex align-items-center gap-2" v-else>
                          <input type="checkbox" :id="`car_types_parent_${props.option.id}`" :checked="checkCarChecked(props.option)">
                          <span class="option__small">{{ props.option.car_types_parent }}</span>
                        </div>
                        </template>
                        <template #selection="{ values, search, isOpen }">
                          <span class=""
                                v-if="values.length == 0 || selectedCarTypeParent.length == zzCarTypesParent[0].attributes.length"
                                >車両タイプ: 全て</span>
                          <span class="multiselect__single"
                            v-if="values.length && values.length != zzCarTypesParent[0].attributes.length"
                            >{{ selectedCarTypeParent.map(item => item.car_types_parent).join('、') }}</span>
                        </template>
                    </Multiselect>
                  </b-col>
                  <b-col sm="auto" class="multiple-select-custom">
                    <Multiselect
                      :options="zzReservationStatus1"
                      :multiple="true"
                      v-model="selectedReservationStatus1"
                      @input="onChangeReservationStatus"
                      placeholder=""
                      :close-on-select="false"
                      group-values="attributes"
                      group-label="selectAll"
                      label="reservation_status_1"
                      track-by="id"
                      :group-select="true"
                      selectLabel=""
                      selectGroupLabel=""
                      deselectLabel=""
                      deselectGroupLabel=""
                      selectedLabel=""
                    >
                      <template #option="props">
                        <div class="option__desc d-flex align-items-center gap-2" v-if="props.option['$groupLabel']">
                          <input type="checkbox" @click.self.prevent="checkedAllReservationStatus()" id="reservation_status_1_all" :checked="checkedAllReservationStatus()">
                          <span class="option__small">{{ props.option.$groupLabel }}</span>
                        </div>
                        <div class="option__desc d-flex align-items-center gap-2" v-else>
                          <input type="checkbox" :id="`reservation_status_1_${props.option.id}`" :checked="checkedReservationStatus(props.option)">
                          <span class="option__small">{{ props.option.reservation_status_1 }}</span>
                        </div>
                      </template>
                      <template #selection="{ values, search, isOpen }">
                        <span class=""
                              v-if="values.length == 0 || selectedReservationStatus1.length == zzReservationStatus1[0].attributes.length"
                              >状態: 全て</span>
                        <span class="multiselect__single"
                          v-if="values.length && values.length != zzReservationStatus1[0].attributes.length"
                          >{{ selectedReservationStatus1.map(item => item.reservation_status_1).join('、') }}</span>
                      </template>
                    </Multiselect>
                  </b-col>
                </b-row>
              </b-col>
            <b-col cols="12">
              <FullCalendar
                class="list-schedule"
                ref="fullcalendar"
                :events="true"
                :options='calendarOptions'
              >
                <template v-slot:eventContent="arg">
                  <div :id="`event-schedule-${arg.event.extendedProps.schedule_id_tooltip}`">
                    <span class="fw-600 fc-event-title-container text-dark" v-if="arg.event.extendedProps.discharger_name">{{ arg.event.extendedProps.discharger_name }}</span>
                    <span class="fw-600 fc-event-title-container text-dark" v-if="arg.event.extendedProps.google_schedule_title">{{ arg.event.extendedProps.google_schedule_title }}</span>
                    <span class="fw-600 fc-event-title-container text-dark" v-if="arg.event.extendedProps.factory_predetermined_id">{{ arg.event.extendedProps.factory_predetermined_title }}</span>
                    <span class="fw-600 fc-event-title-container text-dark" v-if="arg.event.extendedProps.car_predetermined_schedule_id">{{ arg.event.title }}</span>
                    <span class="fw-600 fc-event-title-container text-dark" v-if="arg.event.extendedProps.staff_predetermined_id">{{ arg.event.extendedProps.staff_predetermined_title }}</span>
                    
                    <!-- Start ToolTip area -->
                    <b-tooltip
                      custom-class="schedule-tooltip-custom"
                      :target="`event-schedule-${arg.event.extendedProps.schedule_id_tooltip}`"
                      triggers="hover"
                      placement="right"
                      v-if="!arg.event.extendedProps.car_predetermined_schedule_id && !arg.event.extendedProps.google_schedule_id"
                    >
                    <div class="text-dark me-1" :class="arg.event.extendedProps.isHasDflex && 'text-nowrap'">
                      {{ arg.event.extendedProps.start_hour }} -
                      {{ arg.event.extendedProps.end_hour }}
                    </div>
                    <div class="text-dark" v-if="arg.event.extendedProps.discharger_name">
                      {{ arg.event.extendedProps.discharger_name }}
                    </div>
                    <div class="text-dark" v-if="arg.event.extendedProps.discharger_site_name">
                      {{ arg.event.extendedProps.discharger_site_name }}
                    </div>
                    <div class="text-dark" v-if="arg.event.extendedProps.vendor">
                      {{ arg.event.extendedProps.vendor }}
                    </div>
                    <div class="text-dark" v-if="arg.event.extendedProps.work_order_name">
                      {{ arg.event.extendedProps.work_order_name }}
                    </div>
                    <div
                      class="text-dark" v-if="arg.event.extendedProps.waste_or_services_by_schedule"
                    >
                      {{ getWasteOrServiceNameWithQuantity(arg.event.extendedProps.waste_or_services_by_schedule) }}
                    </div>
                    <div
                      class="text-dark" v-if="arg.event.extendedProps.waste_or_services_by_schedule"
                    >
                      {{ getVendorNameForTooltip(arg.event.extendedProps.waste_or_services_by_schedule) }}
                    </div>
                    <div class="text-dark" v-if="arg.event.extendedProps.zz_reservation_status2">
                      {{ arg.event.extendedProps.zz_reservation_status2.reservation_status_2 }}
                    </div>
                    <div class="text-dark" v-if="arg.event.extendedProps.work_reservation_remarks">
                      {{ arg.event.extendedProps.work_reservation_remarks }}
                    </div>
                    <div class="text-dark">
                      {{ getAssignStaffName(arg.event.extendedProps.assigned_staffs_by_schedule) }}
                    </div>
                    <div class="text-dark" v-if="arg.event.extendedProps.implements">
                      {{ getImplements(arg.event.extendedProps.implements) }}
                    </div>
                    <div
                      class="text-dark" v-if="arg.event.extendedProps.waste_or_services_by_schedule"
                    >
                      {{ getWasteManifestPreparationRole(arg.event.extendedProps.waste_or_services_by_schedule) }}
                    </div>
                    <div class="text-dark" v-if="arg.event.extendedProps.discharger_site_user1_name">
                      {{ arg.event.extendedProps.discharger_site_user1_name }}
                    </div>
                    <div class="text-dark" v-if="arg.event.extendedProps.assigned_cars_by_schedule"
                    >
                      {{ getAssignCarName(arg.event.extendedProps.assigned_cars_by_schedule) }}
                    </div>
                  <div class="text-dark preline" v-if="arg.event.extendedProps.waste_or_services_by_schedule">
                    {{ getNumberOfRentalContainers(arg.event.extendedProps.waste_or_services_by_schedule) }}
                  </div>
                    <div class="text-dark" v-if="arg.event.extendedProps.waste_or_services_by_schedule">
                      {{ getCommentToUser(arg.event.extendedProps.waste_or_services_by_schedule) }}
                    </div>
                  </b-tooltip>
                  </div>
                </template>
              </FullCalendar>
            </b-col>
            <div :class="`button-collapse in`" v-b-toggle.sidebar-right>
              <div class="" style="margin-left: 5px;">
              <span class="fa fa-chevron-left fa-lg cursor-pointer"></span>
            </div>
            <div class="title mt-2 headline-type-1 headline-small">予約一覧の表示</div>
            </div>
            <b-sidebar no-close-on-route-change id="sidebar-right" bg-variant="white" title="" right shadow>
              <TabReservations class="tab-reservations"/>
            </b-sidebar>
          </b-row>
        </b-card>
      </b-overlay>
    </b-row>
  </Layout>
</template>

<style lang="scss">
.custom-card {
  .card-body {
    padding: 1rem 1.25rem;
    .col-sm-auto {
      &.multiple-select-custom {
       min-width: 155px;
       max-width: 300px;
      }
      margin-top: 0.25rem;
      padding-right: calc(var(--bs-gutter-x) / 5);
      padding-left: calc(var(--bs-gutter-x) / 5);
    }
  }
}

.list-schedule.fc {
  .fc-timeline-event.fc-event {
    cursor: pointer;
    margin: 0 0 10px;
  }

  .fc-text-black > * > a {
    color: black;
  }

  .fc-direction-ltr .fc-timeline-event.fc-event.fc-event-end{
    margin-right: 0;
  }

  .fc-timeline-header-row-chrono {
    .fc-timeline-slot-frame {
      justify-content: center;
    }
  }
  .fc-datagrid-cell-main {
    white-space: pre-wrap;
  }
}
.button-collapse {
  position: fixed;
  top: 125px;
  white-space: nowrap;
  right: 0%;
  background-color: #2C3E50;
  color: white;
  height: auto;
  margin: 8px 0 8px 8px;
  padding: 8px 0 10px 10px;
  width: 40px;
  cursor: pointer;
}
.tab-reservations {
  margin: 20px;
  width: 525px;
}
.margin-sm {
  margin-right: 5px;
}
.headline-small {
  font-size: 16px;
    line-height: 1.4;
}
.headline-type-1 {
    -ms-writing-mode: tb-rl;
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
    text-align: center;
    vertical-align: center;
    text-orientation: upright;
    font-feature-settings: initial;
    white-space: nowrap;
    letter-spacing: 10px;
}
.fc-event-title-container {
  display: block;
  text-align: start;
  white-space: nowrap;
  overflow: hidden;
}
.preline { 
    white-space: pre-line; 
}
</style>
